/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitOAuthCodesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {SubmitOAuthCodesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const submitOauthCodes = (request: SubmitOAuthCodesRequest, options?: CashRequestOptions) => post<SubmitOAuthCodesRequest, SubmitOAuthCodesResponse>("/2.0/cash/submit-oauth-codes", request, {...options, rejectOnError: true })